import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { useLocaleKeys } from '~/i18n';
import { AGREEMENTS_SERVICE_FIELD_GRAMMAR } from './agreementsServiceFields';
import { useAgreementsChipConnector } from './chips/agreementsChipConnector';
const stateFieldsFor = (agreementTexts)=>[
        {
            field: 'automaticState',
            fieldLabel: agreementTexts.filters.labels.automaticServices(),
            items: [
                {
                    value: 'active',
                    label: agreementTexts.filters.automaticOptions.active()
                },
                {
                    value: 'paused',
                    label: agreementTexts.filters.automaticOptions.paused()
                }
            ],
            biSuffix: 'automatic_state'
        },
        {
            field: 'completionState',
            fieldLabel: agreementTexts.filters.labels.completion(),
            items: [
                {
                    value: 'completed',
                    label: agreementTexts.filters.completionOptions.completed()
                },
                {
                    value: 'notCompleted',
                    label: agreementTexts.filters.completionOptions.notCompleted()
                }
            ],
            biSuffix: 'status'
        }
    ];
export const agreementsServiceGrammar = (param)=>{
    let { texts, agreementTexts, connector, serviceNames } = param;
    return _object_spread_props(_object_spread({}, AGREEMENTS_SERVICE_FIELD_GRAMMAR), {
        stateFields: stateFieldsFor(agreementTexts),
        useNameOptions: ()=>serviceNames,
        texts,
        connector,
        biPrefix: 'agreements_ai_chip_service',
        summaryBi: {
            toggleQuantifier: 'agreements_ai_chip_service_toggle_quantifier',
            remove: 'agreements_ai_chip_service_remove'
        },
        // WHY: the widened rebuild really is an agreements service predicate. Values: every set a chip
        // writes comes from the `allowed` lists this grammar declares, except billedUpon, recurrence and
        // discount.expiration, which serviceBilling.ts and serviceDiscountExpiration.ts take from the
        // shared/drafts enums — agreementChipCoverage.test.ts pins all three inside the agreements lists.
        // Keys: a key outside this grammar's `fields` is never written by a chip, which is the whole of
        // what the cast rests on.
        toEntityPredicate: (predicate)=>predicate
    });
};
export const useAgreementsServiceGrammar = (serviceNames)=>{
    const { t } = useLocaleKeys('proposal.draftsDashboard.aiSearch');
    const { t: agreementTexts } = useLocaleKeys('agreement');
    const connector = useAgreementsChipConnector();
    return agreementsServiceGrammar({
        texts: t,
        agreementTexts,
        connector,
        serviceNames
    });
};
